interface UploadFilledProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const UploadFilled = ({ className = '', ...props }: UploadFilledProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M5 20H19V18H5V20ZM5 10H9V16H15V10H19L12 3L5 10Z" fill="currentColor" />
    </svg>
  );
};

export default UploadFilled;
